import { JSX } from "react";
import cx from "classnames";
import { valueOrDashes } from "@app/shared/utility/valueOrDashes";
import { getClaimsVolumeDefinitions } from "@app/projects/servicing-provider/ServicingProviderHelpers";
import InfoIndicator from "@app/shared/InfoIndicator";

interface ClaimVolumes {
  commercialClaimsVolumeDisplay?: string;
  medicaidClaimsVolumeDisplay?: string;
  medicareClaimsVolumeDisplay?: string;
  vaClaimsVolumeDisplay?: string;
  tricareClaimsVolumeDisplay?: string;
  totalClaimsVolumeDisplay?: string;
}

interface ProviderClaimVolumesProps {
  claimVolumes: ClaimVolumes;
  showVA: boolean;
  showTricare: boolean;
  className?: string;
  testId: string;
}

/**
 * ProviderClaimVolumes component
 * This component displays claim volumes for a provider.
 */
const ProviderClaimVolumes = (props: ProviderClaimVolumesProps): JSX.Element => {
  return (
    <div
      className={cx({ [props.className]: !!props.className, "data-box": true })}
      data-testid={props.testId}
    >
      <div className="data-box-header">
        Claims Volume <InfoIndicator className={"informational-indicator"} tooltipTitle={getClaimsVolumeDefinitions()} />
      </div>
      <div className="data-box-content">
        Total: {valueOrDashes(props.claimVolumes.totalClaimsVolumeDisplay, false)}
      </div>
      <div className="data-box-content">
        Medicare: {valueOrDashes(props.claimVolumes.medicareClaimsVolumeDisplay, false)}
      </div>
      <div className="data-box-content">
        Medicaid: {valueOrDashes(props.claimVolumes.medicaidClaimsVolumeDisplay, false)}
      </div>
      <div className="data-box-content">
        Commercial: {valueOrDashes(props.claimVolumes.commercialClaimsVolumeDisplay, false)}
      </div>
      {props.showVA && (
        <div className="data-box-content">
          VA: {valueOrDashes(props.claimVolumes.vaClaimsVolumeDisplay, false)}
        </div>
      )}
      {props.showTricare && (
        <div className="data-box-content">
          TRICARE: {valueOrDashes(props.claimVolumes.tricareClaimsVolumeDisplay, false)}
        </div>
      )}
    </div>
  );
};

export default ProviderClaimVolumes;